export default __webpack_public_path__ + "static/media/CardCut.ed1a0607.svg";